import { useState } from 'react'
import Dashboard from './pages/Dashboard'
import LessonPlan from './pages/LessonPlan'
import Grading from './pages/Grading'
import './App.css'

type Page = 'dashboard' | 'lesson-plan' | 'grading'

// API Base URL - Cloudflare Worker
export const API_BASE_URL = 'https://eduspark-api.joanjiaocn.workers.dev'
export const USE_MOCK = false // 使用真实 API

function App() {
  const [currentPage, setCurrentPage] = useState<Page>('dashboard')

  const navigateTo = (page: Page) => {
    setCurrentPage(page)
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
      {currentPage === 'dashboard' && <Dashboard onNavigate={navigateTo} />}
      {currentPage === 'lesson-plan' && <LessonPlan onBack={() => navigateTo('dashboard')} />}
      {currentPage === 'grading' && <Grading onBack={() => navigateTo('dashboard')} />}
    </div>
  )
}

export default App